<template>
  <div>
    <!-- Header -->
    <section class="section-header">

      <!-- Header: title -->
      <div class="section-header-title">
        <span>{{ $t('doc_info.my_review') }}</span>
        <span v-if="note_existed">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn small icon v-on="on"
                ><v-icon small>more_vert</v-icon></v-btn>
            </template>
            <v-list dense>
              <v-list-item 
                @click="exportDoc(html,title_cab,title);gaClick('documentNote_btn_export')">
                <v-list-item-title>{{ $t('note.export') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="delete_dialog=true">
                <v-list-item-title>{{ $t('note.delete') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </div>

      <!-- Header: tools -->
      <div class="section-header-tools">

        <!-- Note is not existed -->
        <div v-if="!note_existed" @click.stop="createDocumentNote()"
          class="underlined-element">
          {{ $t('doc_info.add_review') }}
        </div>

        <!-- Note is existed -->
        <div v-else-if="opened_review" class="header-tools">

          <!-- Case 1: error -->
          <div class="header-alert" v-if="save_error||draft_error">
            <span v-if="save_error" class="saving">{{ $t('proj_note.save_error') }}</span>
            <span v-else class="saving">{{ $t('proj_note.draft_error') }}</span>
          </div>

          <!-- Case 2: saving -->
          <div class="header-alert" v-else-if="!!ing">
            <span class="saving">{{ $t('proj_note.saving_draft') }}</span>
          </div>

          <!-- Case 3: saved -->
          <div class="header-alert" v-else-if="!dirty">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span class="saved" v-on="on">{{ $t('proj_note.all_changes_saved') }}</span>
              </template>
              <!-- Last modified -->
              <div>
                <span>{{ $t('note.last_modified') }}:</span>
                <span>{{ modified_ts }}</span>
              </div>
              <!-- Storage -->
              <div>
                <span class="storage">
                  <span>{{ $t('note.storage') }}: </span>
                  <span v-if="!!new_note">{{ note_bytes_form }}</span>
                  <span v-else>0.0 MB</span>
                  <span>/ 2.0 MB</span>
                </span>
              </div>
            </v-tooltip>
          </div>

          <!-- Case 4: draft saved -->
          <div class="header-alert" v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-if="focused" class="saving" v-on="on">
                  {{ $t('note.not_saved') }}
                  </span>
                <span v-else class="saving" v-on="on">
                  {{ $t('proj_note.draft_is_saved') }}
                </span>
              </template>
              <!-- Last modified -->
              <div>
                <span>{{ $t('note.last_modified') }}:</span>
                <span>{{ modified_ts }}</span>
              </div>
              <!-- Storage -->
              <div>
                <span class="storage">
                  <span>{{ $t('note.storage') }}: </span>
                  <span v-if="!!new_note">{{ note_bytes_form }}</span>
                  <span v-else>0.0 MB</span>
                  <span>/ 2.0 MB</span>
                </span>
              </div>
            </v-tooltip>
          </div>

          <div class="focused-button" v-if="!!dirty||draft_error||save_error">
            <div>
              <v-btn small dark rounded depressed color="primary"
                @click="saveNote()">{{ $t('note.save') }}</v-btn>
              <v-btn small text @click="cancel_dialog=true">{{ $t('note.cancel') }}</v-btn>
            </div>
          </div>
        </div>

        <v-btn v-if="note_existed" class="header-button"
          icon @click="opened_review=!opened_review">
          <v-icon v-if="!opened_review">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
      </div>

    </section>

    <!-- Contents -->
    <div class="contents-wrap" v-if="note_existed&&opened_review" :key="card_key">
      <v-divider></v-divider>

      <div class="contents">
        <!-- <div class="contents-title">리뷰</div> -->
        <!-- Editor -->
        <editor-tiptap-bubble
          :note="note"
          :newnote.sync="new_note"
          :html.sync="html"
          :ing.sync="ing"
          :dirty="dirty"
          :focused.sync="focused">
        </editor-tiptap-bubble>
      </div>
    </div>

    <!-- Modals -->

    <!-- Delete modal -->
    <template>
      <v-dialog v-model="delete_dialog"
        width="400px">
        <v-card>
          <v-card-title>{{ $t('note.delete_review') }}</v-card-title>
          <v-card-text>
            <div>{{ $t('note.delete_alert') }}</div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-btn text @click="delete_dialog=false">{{ $t('note.cancel') }}</v-btn>
            <v-btn text color="primary" @click="deleteDocumentNote()">{{ $t('note.continue') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    
    <!-- Load modal -->
    <template>
      <v-dialog v-model="load_dialog" width="400px">
        <v-card>
          <v-card-title>{{ $t('proj_note.not_loaded') }} </v-card-title>
          <v-card-text>
            {{ $t('proj_note.not_loaded_description') }}
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn depressed small color="primary"
              @click="getDocNoteInfo()">{{ $t('proj_note.reload') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Draft modal -->
    <template>
      <v-dialog v-model="draft_dialog" width="400px">
        <v-card>
          <v-card-title>{{ $t('proj_note.draft_not_saved') }}</v-card-title>
          <v-card-text>
            <div v-if="is_storable">
              {{ $t('proj_note.draft_not_saved_description') }}
            </div>
            <div v-else>
              {{ $t('proj_note.not_storable') }}
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn depressed small color="primary"
              @click="draft_dialog=false;ing=false">
              {{ $t('proj_note.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Save modal -->
    <template>
      <v-dialog v-model="save_dialog" width="400px">
        <v-card>
          <v-card-title>{{ $t('proj_note.note_not_saved') }}</v-card-title>
          <v-card-text>
            <div v-if="is_storable">
              {{ $t('proj_note.note_not_saved_description') }}
            </div>
            <div v-else>
              {{ $t('proj_note.not_storable') }}
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn depressed small color="primary"
              @click="save_dialog=false;ing=false">
              {{ $t('proj_note.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Crash modal -->
    <template>
      <v-dialog v-model="crash_dialog" width="400px">
        <v-card>
          <v-card-title>{{ $t('proj_note.note_crashed') }}</v-card-title>
          <v-card-text>
            {{ $t('proj_note.note_crashed_description') }}
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn depressed small color="primary"
              @click="crash_dialog=false">
              {{ $t('proj_note.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Cancel modal -->
    <template>
      <v-dialog scrollable v-model="cancel_dialog" max-width="800px">
        <v-card v-if="!!pre_note">
          <v-card-title>{{ $t('proj_note.cancel_note') }}</v-card-title>
          <v-card-text>
            <div v-html="JSON.parse(pre_note).data"></div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn text small
              @click="cancel_dialog=false">
              {{ $t('proj_note.cancel') }}
            </v-btn>
            <v-btn depressed small color="primary"
              @click="cancelDraft()">{{ $t('proj_note.confirm') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Crash modal -->
    <template>
      <v-dialog v-model="merge_dialog" width="400px">
        <v-card>
          <v-card-title>도큐먼트 노트가 결합되었습니다.</v-card-title>
          <v-card-text>
            노트를 작성해주신 도큐먼트가 중복된 것으로 판명되어 결합되었습니다. 결합된 노트의 내용을 확인하신 뒤 '저장' 버튼을 눌러주세요.
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn depressed small color="primary"
              @click="merge_dialog=false">
              {{ $t('proj_note.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { formatBytes, exportDoc, toDatetime } from '../../../custom/function'

export default {
  props: {
    title: {
      type: String,
    },
    dockey: {
      required: true,
    },
  },

  data() {
    return {
      title_cab: 'BT_Review_',
      opened_review: true,

      dirty: 0,

      pre_draft: null,
      pre_note: null,

      note: null,
      modified_ts: null,
      is_encrypted: null,

      card_key: 0,
      load_dialog: false,

      new_note: null,
      ing: false,

      note_bytes: 0,
      note_bytes_form: null,

      draft_error: false,
      draft_dialog: false,

      save_error: false,
      save_dialog: false,

      crash_dialog: false,
      crashed_note: null,

      cancel_dialog: false,

      merge_dialog: false,

      html: null,
      focused: false,

      delete_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      note_info: 'notes/doc_note_info',
    }),

    note_existed() {
      if (!!this.note_info) {
        return !!Object.keys(this.note_info).length
      } else {
        return false
      }
    },

    proj_id() {
      return this.$route.params.id
    },

    is_storable() {
      return this.note_bytes < 2000000
    },
  },

  watch: {
    dockey: {
      async handler(val) {
        if (!!val) {
          await this.getDocNoteInfo()
        } else {
          this.$store.commit('notes/resetDocNoteInfo')
          this.note = null
          this.focused = false
          this.dirty = 0
          this.initiate()
        }
      },
      immediate: true,
    },

    new_note(val) {
      let pre_draft_data = null
      if (!!val) {
        this.note_bytes = Buffer.from(this.new_note).length
        this.note_bytes_form = this.formatBytes(this.note_bytes)
        if (!!this.pre_draft) {
          pre_draft_data = JSON.parse(this.pre_draft).data
        }
        if (val!=pre_draft_data) {
          this.saveDraft()
        } else {
          this.ing = false
        }
      }
    }
  },

  methods: {
    formatBytes,
    exportDoc,
    toDatetime,

    initiate() {
      this.modified_ts = null
      this.is_encrypted = null
      this.ing = false
      this.note_bytes = 0
      this.note_bytes_form = null
      this.draft_error = false
      this.draft_dialog = false
      this.save_error = false
      this.save_dialog = false
      this.crashed_note = null
      this.crash_dialog = false
      this.cancel_dialog = false
    },

    async getDocNoteInfo() {
      let error = false
      try {
        await this.$store.dispatch('notes/getDocNoteInfo', this.dockey)
      } catch(e) {
        error = true
      } finally {
        if (!error) {
          this.initiate()

          let note_info = this.$store.getters['notes/doc_note_info']

          if (!!note_info) {
            this.dirty = note_info.dirty
            this.pre_note = note_info.note
            this.pre_draft = note_info.draft

            if (!!this.dirty) {
              if (!this.pre_draft) { this.note = null }
              else if (Array.isArray(JSON.parse(this.pre_draft))) 
                { this.mergeNotes() }
              else { this.parseNote(this.pre_draft) }
            } else {
              if (!this.pre_note) { this.note = null }
              else {
                if (Array.isArray(JSON.parse(this.pre_note)))
                  { this.mergeNotes() }
                else { this.parseNote(this.pre_note) }
                this.note_bytes = Buffer.from(this.note).length
                this.note_bytes_form = this.formatBytes(this.note_bytes)
              }

            }
          }
          else {
            this.$store.commit('notes/resetDocNoteInfo')
            this.note = null
            this.focused = false
            this.dirty = 0
          }

          this.card_key += 1

        } else {
          this.load_dialog = true
        }
      }
    },

    parseNote(note) {
      let parsed_note = JSON.parse(note)
      this.note = parsed_note.data
      this.modified_ts = this.toDatetime(new Date(parsed_note.modified_ts))
      this.is_encrypted = parsed_note.is_encrypted
    },

    mergeNotes() {
      let pre = !!this.dirty ? JSON.parse(this.pre_draft)
        : JSON.parse(this.pre_note)
      let m_note = ''
      let m_modified_ts = 0
      let m_is_encrypted = false
      if (!pre.length) {
        this.note = null
      }
      else if (pre.length==1) {
        this.note = pre[0].data
        this.modified_ts = this.toDatetime(new Date(pre[0].modified_ts))
        this.is_encrypted = pre[0].is_encrypted
      }
      else {
        try {
          for (let i=0; i<pre.length; i++) {
            let parsed_note = pre[i]
            m_note = m_note + '<p>---' +
              this.toDatetime(new Date(parsed_note.modified_ts))
              + '---</p>' + parsed_note.data
            m_modified_ts = Math.max(m_modified_ts, parsed_note.modified_ts)
            m_is_encrypted = m_is_encrypted || parsed_note.is_encrypted
          }
        } finally {
          this.note = m_note
          this.modified_ts = this.toDatetime(new Date(m_modified_ts))
          this.is_encrypted = m_is_encrypted
          this.merge_dialog = true
        }
      }
    },

    async checkCrash() {
      let result = false
      let error = false
      try {
        await this.$store.dispatch('notes/getDocNoteInfo', this.dockey)
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
        error = true
        result = true
      } finally {
        if (!error) {
          let new_note_info = this.$store.getters['notes/doc_note_info']
          if (!this.crashed_note&&(!!new_note_info&&!!new_note_info.draft)&&
            (!this.pre_draft||(JSON.parse(this.pre_draft).modified_ts < 
            JSON.parse(new_note_info.draft).modified_ts))) {
              this.crashed_note = this.getMergeNote(this.new_note, new_note_info.draft)
              this.crash_dialog = true
              this.note = this.crashed_note
              this.card_key += 1
              result = true
          }
        }
        return result
      }
    },

    getMergeNote(note, crashed_note_obj) {
      let parsed_crashed_note = JSON.parse(crashed_note_obj)
      return note + '<p>---' + 
        this.toDatetime(new Date(parsed_crashed_note.modified_ts))
         + '---</p>' + parsed_crashed_note.data
    },

    async saveDraft() {
      let error = false
      let saving_note_obj = {
        data: this.new_note,
        modified_ts: Date.now(),
        is_encrypted: this.is_encrypted,
      }
      try {
        let crashed = await this.checkCrash()
        if (!crashed) {
          if (this.is_storable) {
            try {
              await this.$store.dispatch('notes/saveDocNoteDraft', {
                note_id: this.note_info.note_id,
                draft: JSON.stringify(saving_note_obj)
              })
            } catch(e) {
              error = true
            } finally {
              if(!error) {
                this.pre_draft = JSON.stringify(saving_note_obj)
                this.modified_ts = this.toDatetime(new Date(saving_note_obj.modified_ts))
                this.ing = false
                this.dirty = 1
                this.crashed_note = null
                this.draft_error = false
                this.save_error = false
              }
            }
          } else {
            error = true
          }
        }
      } finally {
        this.draft_error = error
        if (this.draft_error) { this.draft_dialog = true }
      }
    },

    async saveNote() {
      let error = false
      let saving_note_obj = {
        data: this.new_note,
        modified_ts: Date.now(),
        is_encrypted: this.is_encrypted,
      }
      try {
        let crashed = await this.checkCrash()
        if (!crashed) {
          if(this.is_storable) {
            try {
              await this.$store.dispatch('notes/saveDocNote', {
                note_id: this.note_info.note_id,
                note: JSON.stringify(saving_note_obj),
                doc_key: this.dockey,
              })
            } catch(e) {
              error = true
            } finally {
              if (!error) {
                await this.getDocNoteInfo()
              }
            }
          }
        }
      } finally {
        this.save_error = error
        if ( this.save_error ) { this.save_dialog = true }
      }
    },

    async createDocumentNote() {
      let stringified_note = JSON.stringify({
        data: null,
        modified_ts: Date.now(),
        is_encrypted: false,
      })
      try {
        await this.$store.dispatch('document/createDocumentNote', {
          doc_key: this.dockey,
          note: stringified_note,
          proj_id: this.proj_id,
        })
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
      } finally {
        this.$analytics.logEvent('click', { name: 'documentNote_btn_create' })
        this.getDocNoteInfo()
      }
    },

    async deleteDocumentNote() {
      try {
        await this.$store.dispatch('document/deleteDocumentNote', this.note_info.note_id)
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
      }
      finally {
        this.$analytics.logEvent('click', { name: 'documentNote_btn_delete' })
        await this.getDocNoteInfo()
        await this.$store.dispatch('document/getDocument', this.dockey)
        if (!!this.proj_id) {
          await this.$store.dispatch('project/getProject', {
            proj_id: this.proj_id
          })
        } else {
          await this.$store.dispatch('notes/getDocumentNotes')
          this.$router.go()
        }
        this.delete_dialog = false
      }
    },

    async cancelDraft() {
      this.cancel_dialog = false
      let error = false
      try {
        await this.$store.dispatch('notes/cancelDocNoteDraft',
          this.note_info.note_id)
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
        error = true
      }
      finally {
        if (!error) {
          await this.getDocNoteInfo()
        }
      }
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },
  }

}
</script>

<style scoped>
  /* Header */

  .section-header {
    padding: 0 30px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .section-header-title {
    font-size: 14px;
    font-weight: 600;
  }

  .section-header-tools {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-button {
    margin-left: 8px;
  }

  .header-tools {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-alert {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .focused-button {
    margin-left: 8px;
  }

  .ing {
    padding: 0 5px;
  }

  .saving {
    color: #E0457A;
  }

  .saved {
    color: #455ffe;
  }

  .underlined-element {
    text-decoration: underline;
    cursor: pointer;
  }

  /* Contents */

  .contents {
    margin: 20px 30px;
  }

  .contents-title {
    font-weight: 600;
    margin-bottom: 8px;
  }

  /* Modal */

  .actions {
    display: flex;
    justify-content: flex-end;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/document/DocumentNote.vue